module.exports = __webpack_public_path__ + "static/media/arab.5a71d19c.svg";